module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAABHNCSVQICAgIfAhkiAAAANhJREFUOE/Nk2FNA1EQhL9xcBKQ0CqgEpAADkABhwLqoOegJ6E4qAQknINphrwmL03LvWv4wf7c7M7uzOzK9gr4BDYsjwF4k+0DMEhKYlHYTs8UEEvSou5SbDvb9/8cpKzZSRrPNG2/AqOk7yp3m47tJ2APvETwImByq2aQTLL9DOyAuLfOCUg61gY0CVvsfwQ+JPWXDs6CVBS2wPuZWvMmRcRM/qFQUVvXlH7dxPZDJl4R8ShpanKn9XpnNWkB+nOQfKLzyS3TL2oi/lcesMsn5hrvADnkfk7UBrXCMJ/ZvwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/examinatSystem/closeIcon.png
// module id = IH3p
// module chunks = 3